import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchIpInventory,
  fetchIpInventoryTotal,
  fetchIpInventoryGraph,
  fetchIpInventoryAction,
} from "../../actions/inventory";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import GaugeChart from "react-gauge-chart";
// import BasicColumn from "../common/apexChart/basicColumn";
import Pagination from "../Pagination/Pagination";
import BasicColumn from "../common/apexChart/basicLineColumn";
import TrialComponent from "../common/trialComponent";
import NoData from "../common/noDataComponetnt";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import "../../assets/css/recommendation-modal.css";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import { is } from "immutable";
import $, { data } from "jquery";


const IPBlacklist = () => {
  // const id = JSON.parse(localStorage.getItem("user")).organisationId;
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );
  const auth = useSelector((state) => state?.auth?.user);
  const dispatch = useDispatch();
  const [filterData, setfilterData] = useState("all");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [category, setCategory] = useState("all");
  const [search, setSearch] = useState("");
  const [cloudOrISPProvider, setCloudOrISPProvider] = useState("");
  const [location, setLocation] = useState("");
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [limit, setLimit] = useState(10);
  let state = useSelector((state) => state?.inventory?.list);
  let totalRes = useSelector((state) => state?.inventory?.iptotals?.data);
  const scanCompleted = useSelector((state) => state?.inventory?.scanCompleted);

  const scanDetails = useSelector((state) => state?.inventory?.ipgraph?.data);
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
  });
  const compliantPercent = (totalRes?.complaincePercentage || 0) / 100;

  let uniqueCloudProvider = [];
  let ipArray = [];
  if (scanDetails?.scanDetails && Array.isArray(scanDetails.scanDetails)) {
    for (let details = 0; details < scanDetails.scanDetails.length; details++) {
      ipArray.push(scanDetails.scanDetails[details]);
    }
  }

  useEffect(() => {
    if (orgId) {
      fetchIpInventory(orgId, dispatch, page, category, filterData, limit, search, cloudOrISPProvider, location);
    } else {
      fetchIpInventory(id, dispatch, page, category, filterData, limit, search, cloudOrISPProvider, location);
    }
  }, [id, page, category, filterData, limit, search, cloudOrISPProvider, location]);

  useEffect(() => {
    fetchIpInventoryTotal(id, dispatch);
  }, [id]);

  useEffect(() => {
    fetchIpInventoryGraph(id, dispatch);
  }, [id]);

  useEffect(() => {
    setTotalItems(state?.totalIps);
  }, [state?.totalIps]);

  let mapData = state?.data;

  // Ensure mapData is an array
  if (mapData && !Array.isArray(mapData)) {
    mapData = [];
  }

  let currentTableData = [];

  if (mapData && Array.isArray(mapData) && mapData.length > 0) {
    currentTableData = mapData;
  }

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id) || [];
    if ((selectedIds?.length || 0) > 0 || (selectedIds?.length || 0) == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      const currentIds = prevSelectedIds || [];
      const newIds = currentIds.includes(id)
        ? currentIds.filter((selectedId) => selectedId !== id)
        : [...currentIds, id];

      if (newIds.length > 10) {
        setMultiCheckTrue(true);
      } else {
        setMultiCheckTrue(false);
      }

      return newIds;
    });
  };

  const snooze = (_id, event) => {
    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green", // Customize as needed
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                blackListedIPIds: (selectedIds?.length || 0) === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              fetchIpInventoryAction(id, dispatch, page, category, filterData, data, cloudOrISPProvider, location);
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
            // User canceled, do nothing
          },
        },
      });
    }

  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      blackListedIPIds: (selectedIds?.length || 0) == 0 ? ids : selectedIds,
    };
    fetchIpInventoryAction(id, dispatch, page, category, filterData, data, cloudOrISPProvider, location);
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      blackListedIPIds: (selectedIds?.length || 0) == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchIpInventoryAction(id, dispatch, page, category, filterData, data, cloudOrISPProvider, location);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/black-listed-ips/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      // Sanitize filename to prevent XSS: remove special characters and keep only alphanumeric, spaces, hyphens, and underscores
      const sanitizedClientName = (clientName || "client")
        .replace(/[^a-zA-Z0-9\s\-_]/g, "")
        .replace(/\s+/g, "-")
        .substring(0, 100); // Limit length
      link.setAttribute("download", `${sanitizedClientName}Ip-Blacklisted.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  return (
    <div className="container-fluid">
      <AccessPage></AccessPage>
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Blacklisted IP Details</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  Blacklisted IP
                </li>
              </ol>
              <br />
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
            <span className="mr-2">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecommendationModal(true);
                }}
                href="#"
                className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              >
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                Recommendation
              </a>
            </span>
            {mapData?.length === 0 ? null : (
              <a
                onClick={(e) => {
                  e.preventDefault();
                  downloadFile();
                }}
                href="/add-report"
                className="btn btn-sm btn-primary mr-1 download-report"
              >
                Download Details
              </a>
            )}
          </div>
        </div>
      </div>

      {typeof scanCompleted !== "undefined" && !scanCompleted && (
        <div className="card border-success">
          <ScanMessage />
        </div>
      )}

      <div className="row clearfix">
        <div className="col-lg-4 col-md-12">
          <div className="card RecordFoundCard">
            <div className="body" style={{ minHeight: "440px" }}>
              <h6>Compliance</h6>
              <div className="row text-center mb-5 mt-5">
                <GaugeChart
                  id="gauge-chart3"
                  nrOfLevels={30}
                  colors={["#9367B4", "#08283f"]}
                  arcWidth={0.3}
                  percent={(compliantPercent || 0)}
                />
              </div>

              <div className="form-group">
                <label className="d-block">
                  Blacklisted IPs
                  <span className="float-right">
                    {totalRes?.totalBlacklistedIPs || 0}/
                    {totalRes?.totalIPs || 0}
                  </span>
                </label>
                <div className="progress progress-xxs">
                  <div
                    className="progress-bar progress-bar-danger"
                    role="progressbar"
                    aria-valuenow={totalRes?.totalBlacklistedIPs?.toFixed(0)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: totalRes?.totalBlacklistedIPs?.toFixed(0) + "%",
                    }}
                  ></div>
                </div>
              </div>
              {Object?.keys(uniqueCloudProvider || {}).map((key) => {
                let value = uniqueCloudProvider[key];
                let percent =
                  ((value?.length || 0) / (state?.length || 0)) * 100;
                return (
                  <div className="form-group">
                    <label className="d-block">
                      IPs Blacklisted in {key} Servers{" "}
                      <span className="float-right">
                        {value?.length || 0}/{state?.length || 0}
                      </span>
                    </label>
                    <div className="progress progress-xxs">
                      <div
                        className="progress-bar progress-bar-warning"
                        role="progressbar"
                        aria-valuenow={percent?.toFixed(0)}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: percent?.toFixed(0) + "%",
                        }}
                      ></div>
                    </div>
                  </div>
                );
              })}
              {client?.subscriptionType == "trial" && (
                <div className="card border-warning">
                  <TrialComponent />
                </div>
              )}
              {/* <div className="form-group">
                <label className="d-block">
                  IPs Blacklisted in Google Servers{" "}
                  <span className="float-right">
                    {blackListedGoogleServer?.length || 0}/{state?.length || 0}
                  </span>
                </label>
                <div className="progress progress-xxs">
                  <div
                    className="progress-bar progress-bar-warning"
                    role="progressbar"
                    aria-valuenow={blackListedGoogleServerPercent?.toFixed(0)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: blackListedGoogleServerPercent?.toFixed(0) + "%",
                    }}
                  ></div>
                </div>
              </div> */}
              {/* <div className="form-group">
                <label className="d-block">
                  IPs Blacklisted in Microsoft Servers{" "}
                  <span className="float-right">
                    {blacklistedMicrosoftServer?.length || 0}/
                    {state?.length || 0}
                  </span>
                </label>
                <div className="progress progress-xxs">
                  <div
                    className="progress-bar progress-bar-info"
                    role="progressbar"
                    aria-valuenow={blacklistedMicrosoftServerPercent?.toFixed(
                      0
                    )}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width:
                        blacklistedMicrosoftServerPercent?.toFixed(0) + "%",
                    }}
                  ></div>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div className="col-lg-8 col-md-12 col-sm-12">
          <div className="card">
            <div className="body" style={{ minHeight: "440px" }}>
              <h6 className="welcome-textSmall">Previous scan details</h6>
              {scanDetails && (
                <BasicColumn
                  dates={scanDetails?.dates}
                  ipArray={ipArray}
                  color={["#1DBF73", "#1DBF73"]}
                  yAxis="Total Host"
                />
              )}
            </div>
          </div>
        </div>

        <div className="col-lg-12 col-md-12">
          <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
            <li className="nav-item">
              <a
                className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                  }`}
                onClick={() => {
                  setCategory("all");
                  setPage(1);
                  setfilterData("all");
                  setCloudOrISPProvider("");
                  setLocation("");
                }}
              >
                Current
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                  }`}
                onClick={() => {
                  setCategory("risk-accepted");
                  setPage(1);
                  setfilterData("all");
                  setCloudOrISPProvider("");
                  setLocation("");
                }}
              >
                Risk Accepted
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                  }`}
                onClick={() => {
                  setCategory("false-positive");
                  setPage(1);
                  setfilterData("all");
                  setCloudOrISPProvider("");
                  setLocation("");
                }}
              >
                False Positive
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                  }`}
                onClick={() => {
                  setCategory("remidiated");
                  setPage(1);
                  setfilterData("all");
                  setCloudOrISPProvider("");
                  setLocation("");
                }}
              >
                Remediated
              </a>
            </li>
          </ul>
          <div className="card card_tableBox">
            <div className="body">
              <div className="header">
                <div className="row">
                  <div className="col-sm-2 mb-2">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      value={filterData}
                      onChange={(e) => { setfilterData(e.target.value); setPage(1) }}
                    >
                      <option value="all">Status</option>
                      <option value="blacklisted">Blacklisted</option>
                      <option value="not-blacklisted">Not Blacklisted</option>
                    </select>
                  </div>

                  <div className="col-sm-3 mb-2">
                    <div
                      data-test="datatable-input"
                      class="mdb-datatable-filter flex-row"
                    >
                      <input
                        class="form-control form-control-sm ml-0 my-1"
                        type="text"
                        placeholder="IP Address/ Blacklist Database Search"
                        aria-label="Search"
                        // value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                          setPage(1);
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-2 mb-2">
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Cloud/ISP Provider"
                      aria-label="Cloud/ISP Provider Search"
                      value={cloudOrISPProvider}
                      onChange={(e) => {
                        setCloudOrISPProvider(e.target.value);
                        setPage(1);
                      }}
                    />
                  </div>

                  <div className="col-sm-2 mb-2">
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Location"
                      aria-label="Location Search"
                      value={location}
                      onChange={(e) => {
                        setLocation(e.target.value);
                        setPage(1);
                      }}
                    />
                  </div>


                  <div className="col-sm-3 mb-2">
                    {(selectedIds?.length || 0) > 1 && userPermission && category === "all" && (
                      <Box sx={{ width: 160 }}>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedValue}
                            onChange={(event) => {
                              setAction(event.target.value);
                              snooze("", event.target.value);
                            }}
                          >
                            <MenuItem value="pleaseSelect">
                              Snooze Options
                            </MenuItem>
                            <MenuItem
                              value="riskAccepted"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              Risk Accepted
                            </MenuItem>
                            <MenuItem
                              value="markAsFalsePositive"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              False Positive
                            </MenuItem>
                            <MenuItem value="markAsRemidiated">
                              Remediated
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    )}
                    {(selectedIds?.length || 0) > 1 && userPermission &&
                      (category == "false-positive" ||
                        category == "risk-accepted") && (
                        <button
                          className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                          onClick={() => Unsnoozed("")}
                        >
                          Unsnooze
                        </button>
                      )}
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-custom spacing5 mb-0">
                    <thead>
                      <tr>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th>
                              <input
                                type="checkbox"
                                checked={
                                  (selectedIds?.length || 0) == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            </th>
                          )}
                        <th>Status</th>
                        <th>Host Name</th>
                        <th>Cloud / ISP Provider</th>
                        <th>Location</th>
                        <th>Blacklist Database</th>
                        {category !== "all" && <th>Action Note</th>}
                        <th>Created At</th>
                        <th>Updated At</th>
                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th style={{ width: "80" }}>Action</th>
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {client?.subscriptionType == "trial" ? (
                        <tr>
                          <td colSpan={5}>
                            <NoData />
                          </td>
                        </tr>
                      ) : (
                        currentTableData?.map((row, index) => {
                          return (
                            <tr>
                              {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <td>
                                    <input
                                      onClick={() => singleClick(row?._id)}
                                      checked={selectedIds?.includes(row?._id)}
                                      type="checkbox"
                                      className="checkUncheck"
                                    />
                                  </td>
                                )}
                              <td style={{ whiteSpace: "unset" }}>
                                {/* <span>{(page - 1) * 10 + 1 + index}</span> */}
                                <span
                                  className={
                                    row?.isBlackListed == true
                                      ? "badge badge-critical"
                                      : "badge badge-low"
                                  }
                                >
                                  {row?.isBlackListed == true
                                    ? "Blacklisted"
                                    : "Not blacklisted"}
                                </span>
                              </td>
                              <td style={{ whiteSpace: "unset" }}>
                                {row?.ip}
                              </td>
                              <td style={{ whiteSpace: "unset" }}>
                                {row?.cloudOrISPProvider}
                              </td>

                              <td style={{ whiteSpace: "unset" }}>
                                {row?.location}
                              </td>
                              <td style={{ whiteSpace: "unset" }}>
                                {row?.blackListSource && Array.isArray(row.blackListSource) && row.blackListSource.length > 0
                                  ? row.blackListSource.map((source, index) => {
                                    return (
                                      <span
                                        key={`ipblacklist${index}`}
                                        id={`ipblacklist${index}`}
                                        data-tip={source}
                                        className="badge badge-warning"
                                      >
                                        {source}
                                      </span>
                                    );
                                  })
                                  : "N/A"}
                              </td>
                              {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                              <td style={{ whiteSpace: "unset" }}>
                                {moment(row?.createdAt).format("DD-MM-YYYY")}
                              </td>
                              <td style={{ whiteSpace: "unset" }}>
                                {moment(row?.updatedAt || row?.createdAt).format("DD-MM-YYYY")}
                              </td>
                              {row?.remediationPending == true ? <td>Retest in progress</td> :
                                <>
                                  {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                                    <td>
                                      <Box sx={{ width: 160 }}>
                                        <FormControl fullWidth>
                                          <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={selectedValue}
                                            onChange={(event) => {
                                              setAction(event.target.value);
                                              snooze(row?._id, event.target.value);
                                            }}
                                          >
                                            <MenuItem value="pleaseSelect">
                                              Snooze Options
                                            </MenuItem>
                                            <MenuItem
                                              value="riskAccepted"
                                              onClick={() => {
                                                addModal();
                                                setLookalikeAppId([row._id]);
                                              }}
                                            >
                                              Risk Accepted
                                            </MenuItem>
                                            <MenuItem
                                              value="markAsFalsePositive"
                                              onClick={() => {
                                                addModal();
                                                setLookalikeAppId([row._id]);
                                              }}
                                            >
                                              False Positive
                                            </MenuItem>
                                            <MenuItem value="markAsRemidiated">
                                              Remediated
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Box>
                                    </td>
                                  )}
                                </>
                              }
                              {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <td>
                                    <button
                                      className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                      onClick={() => Unsnoozed(row?._id)}
                                    >
                                      Unsnooze
                                    </button>
                                  </td>
                                )}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="dataTables_paginate">
                    {totalItems > 0 && (
                      <Pagination
                        className="pagination-bar"
                        currentPage={page}
                        totalCount={totalItems}
                        pageSize={PageSize}
                        onPageChange={(page) => setPage(page)}
                      />
                    )}
                  </div>
                  {totalItems > 10 && (
                    <select
                      value={limit}
                      onChange={(e) => {
                        setLimit(e.target.value)
                      }}
                      className="form-control limitSelectBox"
                    >
                      <option value={10}>10 per page</option>
                      <option value={25}>25 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                    </select>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModal("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModal("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>

            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek has identified IP addresses associated with your organization that are
                  listed on one or more threat intelligence and reputation blacklists. Blacklisted
                  IPs are commonly associated with spam campaigns, malware hosting, botnet activity,
                  or command-and-control infrastructure.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Is Blacklisted IP Monitoring</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Blacklisted IP monitoring continuously tracks your public-facing IP addresses
                      against global reputation feeds, abuse databases, and threat intelligence sources
                      to identify malicious or suspicious activity linked to your infrastructure.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Common Sources of IP Blacklisting</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Email spam and unsolicited bulk messaging</li>
                      <li>Malware distribution or payload hosting</li>
                      <li>Phishing infrastructure or fake landing pages</li>
                      <li>Botnet command-and-control communication</li>
                      <li>Open proxies, misconfigured servers, or abuse reports</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Security & Business Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Email delivery failures and domain reputation damage</li>
                      <li>Blocking by customers, partners, and ISPs</li>
                      <li>Increased scrutiny from regulators and hosting providers</li>
                      <li>Loss of trust due to association with malicious activity</li>
                      <li>Potential legal or contractual violations</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Threat Intelligence Insight</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Threat actors often exploit exposed services or compromised servers to relay spam
                      or host malicious content. Once detected, these IPs are rapidly shared across
                      global blacklist feeds, amplifying impact across email, web, and API services.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Containment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Identify services running on the blacklisted IP</li>
                      <li>Isolate or suspend affected systems if compromised</li>
                      <li>Block malicious outbound traffic immediately</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.25 · Incident Response</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Root Cause Analysis</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Review logs for spam, brute-force, or malware activity</li>
                      <li>Scan host for malware, web shells, or unauthorized tools</li>
                      <li>Validate exposed ports and services</li>
                    </ul>
                    <div className="compliance-tag">NIST CSF DE.AE</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Reputation Remediation</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Submit delisting requests to blacklist providers</li>
                      <li>Rotate IP addresses if delisting is delayed</li>
                      <li>Implement rate-limiting and abuse protection</li>
                    </ul>
                    <div className="compliance-tag">Email Security & Abuse Management</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Preventive Hardening</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Enable continuous IP reputation monitoring</li>
                      <li>Patch exposed services and OS regularly</li>
                      <li>Restrict outbound traffic via firewall policies</li>
                    </ul>
                    <div className="compliance-tag">CERT-In Network Security Guidelines</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default IPBlacklist;
